const constants = require('@/util/constants')
require('./config')

/**
 * 分页查询
 */
export function getUploads(page, size, type, username, successcb, failedcb) {
    axios.get('/visitor/api/v2/upload/query', {
        params: {
            'page': page,
            'size': size,
            'type': type,
            'username': username,
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 创建
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
// export function createUpload(title, content, attachments, timestamp, successcb, failedcb) {
//     axios.post('/visitor/api/v2/upload/create', {
//         title,
//         content,
//         attachments,
//         timestamp
//     }).then(response => {
//         successcb(response.data)
//     }).catch(error => {
//         failedcb(error)
//     })
// }

/**
 * 更新
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
// export function updateUpload(tid, title, content, attachments, timestamp, successcb, failedcb) {
//     axios.post('/visitor/api/v2/upload/update', {
//         tid,
//         title,
//         content,
//         attachments,
//         timestamp
//     }).then(response => {
//         successcb(response.data)
//     }).catch(error => {
//         failedcb(error)
//     })
// }

/**
 * 删除
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteUpload(id, successcb, failedcb) {
    axios.post('/visitor/api/v2/upload/delete', {
        id
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}
